import { useParams } from "react-router-dom";

export const useUrlMappingCreatePageParams = () => {
  const { siteSlug = "" } = useParams();

  return { siteSlug };
};
